import Vue from "vue";
import { Component } from "vue-property-decorator";
import { EventBus } from "../../Controls/EventBus";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { SocieteReglementsDto } from "../../../dto/GenApi.iNotPaie.Dto/SocieteReglementsDto";
import { ReglementTypeDto } from "../../../dto/GenApi.iNotPaie.Dto/ReglementTypeDto";
import ModalReglements from "./modalReglements/modalReglements";
import { ModalAlerteOptions } from "../../modalComponents/modalAlerte/modalAlerte";
import $ from "jquery";
import EventConstants from "../../Controls/EventConstants";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component({
	components: {
		ModalReglements: require("./modalReglements/modalReglements.vue.html")
	}
})
export default class ReglementsSocieteComponent extends Vue {
	public isModified = false;
	public SocieteReglements: SocieteReglementsDto = { Id: 0, ReglementType: [] };
	public currentReglementType: ReglementTypeDto = { Id: 0, LigneAjoutee: false };
	public dataReady = false;
	public ligneAjoutee = false;
	public modalReglements?: ModalReglements = undefined;
	public currentOrderColumn = "ModeReglement";
	public orderingDesc = true;

	public Init(): void {
    	this.dataReady = false;
    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
			ServicesFactoryInstance.SocieteService.getSocieteReglements(ParametresInstance.societeCourante.Code, (data) => {
    			this.SocieteReglements = data;
    			for (const r of this.SocieteReglements.ReglementType) {
    				if (r.NoSerie != undefined && r.NoSerie > 3) {
						r.LigneAjoutee = true;
					}
    			}
    			this.getClassOfOrder(this.currentOrderColumn, true);
    			this.currentReglementType = this.SocieteReglements.ReglementType[2];
    			this.isModified = false;
    			this.$emit("isModified", false);
    			this.dataReady = true;
    			this.$forceUpdate();
    		});
		}
	}

	public getClassOfOrder(columnName: string, desc: any): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.SocieteReglements != undefined) {
    		this.SocieteReglements.ReglementType.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public ajoutLigne(): void {
    	if (this.modalReglements == undefined) {
			this.modalReglements = this.$refs.modalReglements as ModalReglements;
		}

    	this.modalReglements.Init(this.SocieteReglements);
    	$("#modalReglements").modal("show");
	}

	public update(reglement: ReglementTypeDto): void {
    	if (this.modalReglements == undefined) {
			this.modalReglements = this.$refs.modalReglements as ModalReglements;
		}

    	this.modalReglements.Init(this.SocieteReglements, reglement);
    	$("#modalReglements").modal("show");
	}

	public deleteLigneYes(reglement: ReglementTypeDto): void {
    	for (const o of this.SocieteReglements.ReglementType) {
    		if (reglement.Id != undefined && o.Id == reglement.Id) {
    			this.SocieteReglements.ReglementType.splice(this.SocieteReglements.ReglementType.indexOf(o), 1);
    			ServicesFactoryInstance.SocieteService.updateSocieteReglements(this.SocieteReglements, () => {
    				this.annuler();
    				NotificationServiceInstance.SendSuccess("La société a été modifiée avec succès.");
    				this.$emit("refresh");
    			});
    		}
    	}
	}

	public deleteLigne(reglement: ReglementTypeDto): void {
    	const modalOptions: ModalAlerteOptions = new ModalAlerteOptions({
            message: "Souhaitez-vous vraiment supprimer ce règlement ?",
    		callBackYes: () => {
    			this.deleteLigneYes(reglement);
    		}
    	});
    	EventBus.$emit(EventConstants.MODAL_ALERT, modalOptions);
	}

	public annuler(): void {
    	this.Init();
	}

	public getModeReglement(ModeReglement: string): string {
    	switch (ModeReglement) {
    		case "0": {
    			return "";
    		}
    		case "1": {
    			return "Espèces";
    		}
    		case "2": {
    			return "Chèque";
    		}
    		case "3": {
    			return "Virement";
    		}
    	}

    	return "";
	}

	public getTableauHeight(): string {
    	return "height: " + (70 + this.SocieteReglements.ReglementType.length * 50) + "px;";
	}
}



// WEBPACK FOOTER //
// ./src/components/ficheSociete/reglements/reglementsSociete.ts